import React from 'react';

function AboutPage() {
    return (
        <article className="single-article about-page">
            <header className="article-header">
                <div className="article-header-meta">
                    <span className="eyebrow">Orientation File</span>
                </div>
                <h1 className="article-title">About The Discerner</h1>
                <div
                    className="article-info-bar"
                    style={{ borderBottom: 'none', paddingBottom: 0, marginBottom: 0 }}
                >
                    <span className="small-meta">Agathology + Ponerology</span>
                </div>
            </header>

            <div className="article-content about-content">
                <p className="about-lede">
                    In a distant corner of the world, a small group of Orthodox men met by
                    providence. All of them wanted to write, and all of them felt that certain
                    topics — culture, power, belief — could no longer be discussed openly
                    without consequence. Writing anonymously offered a way to speak truthfully
                    when silence was no longer an option. Gradually more people joined, and
                    The Discerner was born.
                </p>
                <p>
                    The Discerner exists because the world stopped making sense. Stories,
                    outrage cycles, and information from every direction bombard the mind
                    constantly, most of it driven by people with hidden agendas. There is very
                    little space to pause, think, and actually understand what is shaping
                    individuals and societies. It often feels like a war on meaning itself.
                </p>
                <p>
                    This site approaches agathology and ponerology from the perspective of
                    Orthodox Christian laypeople — not guided by politics, trends, online
                    movements, or the need to have a platform. The aim is to think clearly,
                    recognize patterns, and build genuine discernment rather than react
                    emotionally to whatever is loudest this week.
                </p>
                <hr className="about-rule" />
                <p>
                    Every contributor is an Orthodox Christian who actively practices the
                    faith and participates in the sacramental life of the Church. We hold no
                    positions of authority and do not speak on behalf of the Church. As
                    laypeople rooted in prayer and tradition, we try to honestly evaluate the
                    world around us.
                </p>
                <p>
                    This is not a political project and it is not meant to produce fear. It is
                    meant to encourage clarity, careful research, and the freedom to form your
                    own conclusions rather than outsourcing your thinking to whoever has the
                    largest platform.
                </p>
                <hr className="about-rule" />
                <p>
                    Some subjects are difficult because history is often intentionally buried,
                    altered, or left incomplete. When speculation appears in our work, it is
                    marked clearly through our grading system. We try to distinguish between
                    what is documented and what is inferred, so readers can think for
                    themselves rather than adding to the confusion.
                </p>
                <p>
                    Our content covers media, power, culture, symbolism, belief systems, and
                    historical patterns alongside reflections on saints, sacred history,
                    prayer, and the lived life of the Church — or simply whatever we feel most
                    compelled to write about.
                </p>
                <blockquote className="about-verse">
                    “Be not conformed to this world, but be transformed by the renewing of
                    your mind.”<cite>— Romans 12:2</cite>
                </blockquote>
                <hr className="about-rule" />
                <p className="about-contact">
                    Writers interested in contributing can reach us at{' '}
                    <a href="mailto:Admin@discerner.blog">Admin@discerner.blog</a>
                </p>
            </div>
        </article>
    );
}

export default AboutPage;
